export namespace PlayerConfig {

  export interface IVideoInfo {
    title: string;
    director: string;
    year: string;
    description?: string;
    more_info?: {
      text: string;
      url: string;
    };
    copyright: string;
    info_text?: string;
    video_start: number | null;
    loop_start: number | null;
    loop_end: number | null;
  }

  export enum IgnorePageMarginBreakpoints {
    MOBILE,
    SMALL_TABLET,
    TABLET,
  }
}
